import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, FLAT_RATE_BOOKING_TABS } from '@store';

@Component({
  selector: 'app-flat-booking-checkout',
  templateUrl: './flat-booking-checkout.component.html',
  styleUrls: ['./flat-booking-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatBookingCheckoutComponent implements OnDestroy {
  readonly bookingTabs = FLAT_RATE_BOOKING_TABS;
  @Output() reset = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  BookingPlans = SubscriptionPlan;

  constructor(public bookingStore: BookingStore) {}

  onContinue(): void {
    this.bookingStore.subscribeFlatRatePackage();
  }

  onBack(): void {
    this.back.emit();
  }

  onReset(): void {
    this.reset.emit();
  }

  ngOnDestroy(): void {
    this.bookingStore.resetSubscriptionsDetails();
  }
}
